var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('router-view',{on:{"new_language":_vm.updateLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }